var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "tag-grid" },
      _vm._l(_vm.tags, function (tagCloudEntity, tagCloudEntityKey) {
        return _c(
          "div",
          {
            key: tagCloudEntityKey,
            staticClass: "tag-mobile",
            class: [
              tagCloudEntity.state === "active" ? "is-active" : "",
              tagCloudEntity.view === "inspiration" ? "is-inspiration" : "",
            ],
            style:
              "--tagcloud-color: " +
              tagCloudEntity.color +
              "; --tagcloud-color-default: " +
              tagCloudEntity.color +
              "14; --tagcloud-color-hover: " +
              tagCloudEntity.color +
              "1F; --tagcloud-color-active: " +
              tagCloudEntity.color +
              "29;",
            on: {
              click: function ($event) {
                return _vm.selectTag(tagCloudEntity)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "category-filter-item",
                class: { active: tagCloudEntity.state === "active" },
              },
              [
                _c("div", { staticClass: "icon-outer" }, [
                  _c("div", { staticClass: "icon" }, [
                    _c("img", {
                      staticClass: "default",
                      attrs: {
                        src: tagCloudEntity.image_url,
                        alt: tagCloudEntity.label,
                        width: "40",
                        height: "40",
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    "\n          " + _vm._s(tagCloudEntity.label) + "\n        "
                  ),
                ]),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }